import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=671a543e"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.vue?vue&type=style&index=0&id=671a543e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/harness/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('671a543e')) {
      api.createRecord('671a543e', component.options)
    } else {
      api.reload('671a543e', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=671a543e", function () {
      api.rerender('671a543e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Error.vue"
export default component.exports